import type { ReactElement, ReactNode } from 'react';
import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { media } from '../../shared/core/styles';
import { HeadingStyling } from '~/components/unmanaged/styles/BaseStyledStyling';
import { SiteType } from '~/utilities/graphql/codegen';

const styles = {
  GStarTitle: css`
    ${HeadingStyling}
    font-size: var(--title-font-size, 24px);
    color: ${({ theme }) => theme.colors.content.primary};
    text-align: left;
    padding: var(--title-body-padding, var(--ds-spacing-md, 24px) var(--ds-spacing-2xs, 8px) 0);

    @media ${({ theme }) => media(theme).greaterThan('sm')} {
      --title-body-padding: var(--ds-spacing-md, 24px) var(--ds-spacing-sm, 16px) 0;
    }

    @media ${({ theme }) => media(theme).greaterThan('desktop-sm')} {
      --title-font-size: var(--ds-heading-sm, 24px);
      --title-body-padding: var(--ds-spacing-lg, 32px) var(--ds-spacing-md, 24px) 0;
    }

    @media ${({ theme }) => media(theme).greaterThan('tablet')} {
      --title-font-size: var(--ds-heading-md, 32px);
    }

    @media ${({ theme }) => media(theme).greaterThan('xxl')} {
      --title-font-size: clamp(32px, calc(32 * (100 / 1680) * 1vw), 64px);
    }
  `,
  AafTitle: css`
    text-align: center;
    margin: 0;
    padding-block: ${({ theme }) => theme.spacing.y.lg};
    background-color: ${({ theme }) => theme.colors.background.base};
    text-transform: uppercase;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.content.primary};
    font-size: ${({ theme }) => theme.font.size[4]};
    font-family: ${({ theme }) => theme.font.family.primary};
    line-height: 1;
    letter-spacing: 0.8px;
  `,
};

const TitleStyles: Record<SiteType, RuleSet> = {
  [SiteType.Gstar]: styles.GStarTitle,
  [SiteType.Wahts]: styles.GStarTitle,
  [SiteType.Outlet]: styles.GStarTitle,
  [SiteType.Employeeshop]: styles.GStarTitle,
  [SiteType.Aaf]: styles.AafTitle,
};

const S = {
  Title: styled.h1`
    background-color: ${({ theme }) => theme.colors.background.base};
    ${({ theme }) => TitleStyles[theme.siteType]}
  `,
};

interface TitleProps {
  children: ReactNode;
  dataTestId?: string;
  className?: string;
}

export const Title = ({ children, dataTestId, className }: TitleProps): ReactElement => (
  <S.Title data-testid={dataTestId} className={className}>
    {children}
  </S.Title>
);
